import * as Location from "expo-location";

class LocationOps {
    static async getCurrentLocation() {
        const {status} = await Location.requestForegroundPermissionsAsync();

        if (status === 'granted') {
            try {
                return await Location.getCurrentPositionAsync({});
            } catch (error) {
                console.error('Error fetching location:', error);
                throw new Error('Error fetching location.');
            }
        }
    }

    static async getLocationFromAddress(address) {
        const apiKey = 'AIzaSyDTe9cE4XzwFwasKsGQ71h4HVBjm2ZUwCA';
        const encodedAddress = encodeURIComponent(address);
        const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodedAddress}&key=${apiKey}`;

        try {
            const response = await fetch(url);
            const data = await response.json();

            if (data.status === 'OK' && data.results.length > 0) {
                return data.results[0].geometry.location;
            }
        } catch (error) {
            console.error('Error fetching location:', error);
        }
    }

    static async calculateDistance(lat1, lon1, lat2, lon2, isDev = false) {
        const r = 6371; // Earth's radius in kilometers

        const toRadians = (degrees) => degrees * (Math.PI / 180);

        if (isDev) {
            lat1 = 42.20128307588603;
            lon1 = -71.23404566205221;
        }

        const lat1Rad = toRadians(lat1);
        const lat2Rad = toRadians(lat2);
        const deltaLat = toRadians(lat2 - lat1);
        const deltaLon = toRadians(lon2 - lon1);

        // Haversine formula
        const a = Math.sin(deltaLat / 2) ** 2 +
            Math.cos(lat1Rad) * Math.cos(lat2Rad) *
            Math.sin(deltaLon / 2) ** 2;

        const c = 2 * Math.asin(Math.sqrt(a));

        return r * c * 0.621371; // Distance in miles
    }

    static async getPlaceId(lat, lng) {
        const apiKey = 'AIzaSyDTe9cE4XzwFwasKsGQ71h4HVBjm2ZUwCA';
        const response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`);
        const data = await response.json();

        if (data.status === 'OK') {
            const placeId = data.results[0].place_id;
            return placeId;
        } else {
            console.error('Geocoding API error:', data.status);
            return null;
        }
    };
}

export default LocationOps;